import { FC } from 'react';
import { User } from '@models/user.model';
import { CheckCircle } from '@mui/icons-material';

interface EnableUserModalProps {
  modalClose: () => void;
  enableUser: () => void;
  user: User | undefined;
}

const EnableUserModal: FC<EnableUserModalProps> = ({ user }) => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex-shrink-0">
          <CheckCircle className="h-8 w-8 text-green-500" />
        </div>
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Are you sure you want to enable this user account? This will restore
            their access to the system.
          </p>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 mb-2">
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {user?.firstName} {user?.lastName}
        </p>
        <p className="text-sm font-medium text-gray-900 dark:text-white">
          {user?.email}
        </p>
      </div>
    </div>
  );
};

export default EnableUserModal;
